import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/** Components */
import { HeaderComponent } from './header/header.component';
import { SideMenuComponent } from './side-menu/side-menu.component';


@NgModule({
	declarations: [
		HeaderComponent,
		SideMenuComponent
	],
	imports: [
		CommonModule,
		RouterModule,
	],
	exports: [
		HeaderComponent,
		SideMenuComponent,
	],
})
export class ComponentsModule { }
